import { fontSizes } from '_/config/theme';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, TouchableOpacity } from 'react-native';

import Text from '../Text';

interface GDPRButtonProps {
  onOpen: () => void;
}

export const GDPRButton: React.FC<GDPRButtonProps> = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <TouchableOpacity onPress={onOpen}>
      <View>
        <Text center size={fontSizes.lg}>
          {t('homeScreen.gdpr.buttonLine1', { defaultValue: 'Ao fazer o check-in, você concorda com o Termo de Coleta de Dados' })}
        </Text>
        <Text center fontType="medium" size={fontSizes.lg}>
          {t('homeScreen.gdpr.buttonLine2', { defaultValue: 'Ver termo de Coleta de Dados' })}
        </Text>
      </View>
    </TouchableOpacity>
  );
};
